import LegerTeacher from "../../../../../components/categories/siakad/laporan_adab/leger_sync/HomeTeacher"
export default function Home() {
  
  return (
    <LegerTeacher />
  );
}